module.exports = __webpack_public_path__ + "img/yearVIP.516a463.png";